import { ALLOW_EDIT } from '../../../utils/OperationPermissions';

const DocumentUpload = {
  type: 'mockEntities',
  title: 'Document Import',
  formTitle: 'Document Import',
  formUrl: '/Company/Scan/ManualAttach',
  screenReference: 'DOCUMENT_IMPORT',
  operations: ALLOW_EDIT,
  returnUrl: 'back',
};

export default DocumentUpload;
